import Filter from "./Filter";
import ButtonRandom from "./ButtonRandom";
import {
  IconDroplet,
  IconProgressBolt,
  IconFlame,
  IconSparkles,
  IconLeaf,
  IconMountain,
  IconCrystalBall,
} from "@tabler/icons-react";
import PokemonFilterElement from "./PokemonFilterElement";

const element = [
  {
    elemento: "Water",
    valueEl: "water",
    icon: IconDroplet,
    color: "0dd0ff",
  },
  {
    elemento: "Electric",
    valueEl: "electric",
    icon: IconProgressBolt,
    color: "ffe600",
  },
  {
    elemento: "Fire",
    valueEl: "fire",
    icon: IconFlame,
    color: "ff0d0d",
  },
  {
    elemento: "Fairy",
    valueEl: "fairy",
    icon: IconSparkles,
    color: "c795ff",
  },
  { elemento: "Grass", valueEl: "grass", icon: IconLeaf, color: "42ff00" },
  { elemento: "Rock", valueEl: "rock", icon: IconMountain, color: "b8b8b8" },
  {
    elemento: "Psychic",
    valueEl: "psychic",
    icon: IconCrystalBall,
    color: "8e44ad",
  },
];

export const FilterByElements = ({
  resetSearch,
  pokemonName,
  onCleanFilter,
  setFiltroElement,
}) => {
  //  const [elementFilter, setElementFilter] = useState("water");

  return (
    <div className="allElements">
      <Filter setFiltroElement={setFiltroElement} />
      <div className="all-elements-icons">
        {element.map((el) => (
          <PokemonFilterElement
            resetSearch={resetSearch}
            pokemonName={pokemonName}
            key={el.valueEl + "poke"}
            elementColor={"white"}
            iconEl={el.icon}
            elemento={el}
            onClick={setFiltroElement}
          />
        ))}
      </div>
      <div className="container-random">
        <ButtonRandom onClick={onCleanFilter} />
      </div>
    </div>
  );
};
